import React, { FC } from 'react'
import { useTranslate } from '@/utils/translate/translate-client'
import {
  GParagraphLG,
  GResponsiveText,
  GTitleLG,
  GTitleXL,
  GTitleXS,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'

export const SketchDetailsContent: FC = () => {
  const { t } = useTranslate('tickets')
  return (
    <div className="mt-3 grid gap-16">
      <div>
        <GResponsiveText
          color="giveaway-primary"
          className="mb-3 uppercase"
          MobileTextComponent={GTitleLG}
          DesktopTextComponent={GTitleXL}
        >
          {t('giveawaySketchTitle', 'Freddie Wong Grand Prize Ultimate Creator Kit')}
        </GResponsiveText>
        <GParagraphLG color="giveaway-text-subtle-light" className={'mb-6 pt-3'}>
          {t(
            'giveawaySketchExplainer',
            "To celebrate the upcoming release of SKETCH, we're giving you the chance to win the Grand Prize Freddie Wong Ultimate Creator Kit—a dream setup for any aspiring visual effects artist. This exclusive giveaway includes high-end computers, pro-grade camera gear, and everything you need to bring your wildest ideas to life. You'll also win a 3-day trip to Los Angeles to meet Freddie Wong in person and attend a private masterclass with the VFX legend himself.",
          )}
        </GParagraphLG>
        <GParagraphLG color="giveaway-text-subtle-light">
          {t(
            'giveawaySketchExplainer2',
            'Pre-order your tickets to SKETCH, in theaters August 6, and you’ll be automatically entered to win. This is your shot at a once-in-a-lifetime creator experience.',
          )}
        </GParagraphLG>
      </div>
      <div>
        <GResponsiveText
          color="giveaway-primary"
          className="mb-3 uppercase"
          MobileTextComponent={GTitleLG}
          DesktopTextComponent={GTitleXL}
        >
          {t('giveawaySketchFirstPlace', 'Freddie Wong First Place Winners')}
        </GResponsiveText>
        <GParagraphLG color="giveaway-text-subtle-light" className={'mb-6 pt-3'}>
          {t(
            'giveawaySketchExplainerFirstPlaceV2',
            "Nine additional first-place winners will also be flown out to Los Angeles to take part in the Freddie Wong masterclass experience. Whether you're just starting out or ready to level up your skills, this is a rare chance to learn from one of the best in the business.",
          )}
        </GParagraphLG>
        <GResponsiveText
          color="sketch-pink"
          className="mt-4"
          MobileTextComponent={GTitleXS}
          DesktopTextComponent={GTitleXS}
        >
          {t('giveawayEnterToday', 'Enter today for your chance to win!')}
        </GResponsiveText>
      </div>
    </div>
  )
}
